import {
  CosTokenScene,
  getCosToken,
  putObjectWithCosToken,
  type PutObjectWithCosTokenResult,
} from "./cos-token";

/** 上传结果 */
export type CosUploadFileResult = PutObjectWithCosTokenResult;

export interface CosUploadFileOptions {
  onProgress?: (progress: number) => void;
}

/**
 * 使用临时密钥将文件直传 COS
 */
export const cosUploadFile = async (
  file: File,
  scene: CosTokenScene,
  options?: CosUploadFileOptions
): Promise<CosUploadFileResult> => {
  const token = await getCosToken({ scene });
  return putObjectWithCosToken(token, {
    file,
    onProgress: options?.onProgress,
  });
};
